import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import VuiBox from "components/ui/VuiBox";
import VuiTypography from "components/ui/VuiTypography";
import { authService } from "services";
import { GRADIENTS } from "utils/designTokens";

function Logout() {
  const history = useHistory();

  useEffect(() => {
    const handleLogout = async () => {
      try {
        // Call logout service
        await authService.logout();

        // Add a flag to sessionStorage to prevent redirect loop
        sessionStorage.setItem('justLoggedOut', 'true');

        // Redirect to sign-in page after logout using refresh to clear context
        window.location.href = "/authentication/sign-in";
      } catch (error) {
        console.error("Error during logout:", error);
        sessionStorage.setItem('justLoggedOut', 'true');
      }
    };

    handleLogout();
  }, [history]);

  // Show loading indicator while logging out
  return (
    <VuiBox
      height="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      sx={{
        background: GRADIENTS.pageBg,
      }}
    >
      <CircularProgress color="info" size={60} />
      <VuiTypography color="white" variant="button" fontWeight="medium" mt={2}>
        Logging out...
      </VuiTypography>
    </VuiBox>
  );
}

export default Logout;